//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { TagType } from './Enums';

export class TagSearchOptions extends ItemBase {
    IDs: string[] = [];
    SearchText: string | null = null;
    StudentIDs: string[] = [];
    TeacherIDs: string[] = [];
    Types: TagType[] = [];

    constructor(initializer?: Partial<TagSearchOptions>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "TagSearchOptions";
}
